import React, {ReactElement} from 'react';
// import { Checkbox, IView } from '@framework-controls/core';
import { strings } from 'src/localization';
import * as css from './RepairAdvisor.module.scss';
import { Avatar } from '@framework-controls/core';
import { IconPhone } from 'src/content/icons';
import NoProfile from 'src/content/icons/Profile2.svg';
import NoProfileAccess from 'src/content/icons/ProfileWhite.svg';
import classNames from 'classnames';

export interface IProps {
    name: string;
    phone: string;
    phoneExt: string;
    imageURL: string;
    theme: string;
    ServiceDocs?: boolean;
    phoneClick: (e: any) => void;
}

const RepairAdvisor = (props: IProps) => {
    let phone = props.phone;
    // Format the advisor phone number using regular expressions
    const strippedPhone = ('' + phone).replace(/\D/g, '');
    const match = strippedPhone.match(/^(1|)?(\d{3})?(\d{3})(\d{4})$/);
    if (match) {
        const intlCode = match[1] ? match[1] + '-' : '';
        const areaCode = match[2] ? match[2] + '-' : '';
        phone = `${intlCode}${areaCode}${match[3]}-${match[4]}`;
    }
    let NoProfileImage = NoProfile;
    if (props.theme === 'colorSensitive' || props.theme === 'infiniti' || props.theme === 'jeep' || props.theme === 'lexus' ||
    props.theme === 'toyotaSPM' || props.theme === 'landRover' || props.theme === 'audi' ||
    props.theme === 'cadillac') {
        NoProfileImage = NoProfileAccess;
    }
    let avatarColor: 'default' | 'primary' | 'secondary' | 'contrast' | 'completed' | 'blank' = 'primary';
    if (props.theme === 'mazda') {
        avatarColor = 'completed';
    }
    if (props.theme === 'porsche' || props.theme === 'ford' || props.theme === 'bmw') {
        avatarColor = 'contrast';
    }
    if (props.theme === 'chevrolet' || props.theme === 'bmw') {
        avatarColor = 'blank';
    }
    if (props.theme === 'kia' || props.theme === 'hyundai') {
        avatarColor = 'default';
    }
    let image: ReactElement | string = props.imageURL !== ('' || undefined) ? props.imageURL : NoProfileImage;
    const AdvImgAltTag = props.name + ' ' + strings.Photo;

    const phoneClasses = classNames(
        css.phone,
        {
            [css.marginAbove]: !props.ServiceDocs,
        },
    );

    const titleClasses = classNames(
        {
            [css.marginAbove]: props.imageURL,
        },
    );

    const phoneNumberStyles = classNames(
        css.phoneNumber,
        {
            [css.phoneNumberBMW]: props.theme === 'bmw',
            [css.phoneNumberFord]: props.theme === 'ford',

        },
    );

    const titleStyles = classNames(
        css.title,
        {
            [css.titleBMW]: props.theme === 'bmw',
            [css.titleFord]: props.theme === 'ford',

        },
    );

    const phoneExtStyles = classNames(
        css.phoneExt,
        {
            [css.phoneExtBMW]: props.theme === 'bmw',
            [css.phoneExtFord]: props.theme === 'ford',

        },
    );

    const flexVerticalStyles = classNames(
        css.flexVertical,
        {
            [css.flexVerticalBMW]: props.theme === 'bmw',
        },
    );

    // For ServiceDocs, RepairAdvisor displays differently.
    if (props.ServiceDocs) {
        image = <Avatar
            src={image}
            size={70}
            color={avatarColor}
            alt={AdvImgAltTag}
            borderThickness={0} />;

        return (
            <div className={flexVerticalStyles}>
                {image}
                <p className={titleClasses}>{strings.YourAdvisor}</p>
                <p>{props.name}</p>
                {phone &&
                    <div className={phoneClasses}>
                        <IconPhone className={css.phoneIcon} />
                        <a href={`tel:${phone}`} className={phoneNumberStyles}
                            target='hidden-iframe'>{phone}</a>
                        {props.phoneExt ?
                            <div className={phoneExtStyles}>Ext {props.phoneExt}</div>: ''}
                    </div>
                }
            </div>
        );
    } else {
        return (
            <div>
                <p className={titleStyles}>{strings.YourAdvisor}</p>
                <div className={css.flexbox}>
                    <Avatar
                        src={image}
                        size={60}
                        color={avatarColor}
                        alt={AdvImgAltTag}
                        borderThickness={0}
                    />
                    <div className={css.contactInfo}>
                        <p>{props.name}</p>
                        {phone &&
                            <div className={phoneClasses}>
                                <IconPhone className={css.phoneIcon} />
                                <a href={`tel:${phone}`} className={phoneNumberStyles}
                                    target='hidden-iframe' onClick={(e: any) => props.phoneClick(e)}>{phone}</a>
                                {props.phoneExt ?
                                    <div className={phoneExtStyles}>Ext {props.phoneExt}</div>: ''}
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
};


export default RepairAdvisor;
